import { render } from "./Faq.vue?vue&type=template&id=05777946&scoped=true"
import script from "./Faq.vue?vue&type=script&lang=js"
export * from "./Faq.vue?vue&type=script&lang=js"

import "./Faq.vue?vue&type=style&index=0&id=05777946&scoped=true&lang=css"

import exportComponent from "/home/runner/work/somosteatro/somosteatro/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05777946"]])

export default __exports__